<template>
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
    <p class="font-size-sm mb-1">Parque seleccionado</p>
    <div class="w-100 form-control mb-3">{{seat.name}}</div>

    <p class="font-size-sm mb-1">Precio</p>
    <h2 class="text-primary">S/ 30.00</h2>

    <el-form-item label="Horarios" prop="idschedule" >
        <el-radio-group v-model="ruleForm.idschedule">
            <ul>
                <li v-for="item in listScheduls" :key="item.idschedule">
                    <el-tooltip class="item" effect="dark" :content="'Vacantes disponibles: ' + (item.capacity - item.aforo)" placement="top-end">
                        <el-radio :label="item.idschedule">
                            {{(item.title!='')?item.title:''}}
                            {{' (Inicia '}}{{item.startdate | moment('DD [de] MMMM')}}{{ ') ' }}
                            {{item.schedule}}
                        </el-radio>
                    </el-tooltip>
                </li>
            </ul>
        </el-radio-group>
    </el-form-item>

    <!--<div class="" >
        <span class="">Horarios</span>
        <div class="alert alert-danger" role="alert">
            No se tiene horarios disponibles por ahora.
        </div>
    </div>-->

    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="atras">Atras</button>
    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('ruleForm')">Siguiente</button>
</el-form>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true,
            default: {}
        },
        seat: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data() {
        var checkSchedul = (rule, value, callback) => {
            if (!value) {
                if (this.listScheduls.length == 0)
                    return callback(new Error(`Lo sentimos, no contamos con horarios disponibles.`));
                else
                    return callback(new Error(`Tiene que seleccionar un horario.`));
            } else {
                callback();
            }
        };
        return {
            listScheduls: [],
            ruleForm: {
                idschedule: null
            },
            rules: {
              idschedule: [{
                    validator: checkSchedul,
                    trigger: ['change', 'blur']
                }]
            },
        }
    },
    methods: {
        async init() {
            this.$emit("update:loading", true)
            var formdata = new FormData();
            formdata.append('idseat', this.seat.idseat);
            formdata.append('idproduct', this.product.idproduct);

            let res1 = await axios.post(`${process.env.API1}/presencial/scheduls`, formdata)
            this.listScheduls = res1.data

            this.$emit("update:loading", false)

        },
        atras() {
            this.$emit("update:number", 0)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid)
                    this.$emit("getWizard1", this.ruleForm)
            })
        }

    },
    created() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/wizard1.vue